import { Dialog, DialogActions, DialogContent, DialogTitle, Fab, Grid, makeStyles, TextField, Typography } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import ExitIcon from '@material-ui/icons/Clear';
import React, { useState } from 'react';
import { useGlobal } from 'reactn';
import { IGlobalState, IMyAppState } from '../states/GlobalState';
import { globalStyles } from '../style/GlobalStyles';
import { saveElaborazione } from '../services/api';
import SchedaBudgetDataClass from '../states/BudgetState';
import { SimulazioniSrlDataClass } from '../states/SimulazioneSrlState';
import auth from '../types/auth';

export type SaveModalProps = {
    isOpen: boolean;
    handleClose: any;
    state: IMyAppState | SimulazioniSrlDataClass | SchedaBudgetDataClass | null | undefined;
    // applicazione: number;
}

export default function SalvaElaborazione(props: SaveModalProps) {
    const gClasses = globalStyles();
    const [global] = useGlobal<IGlobalState>();
    const [fileName, setfileName] = useState("");
    const [error, setError] = useState<string>();
    const [success, setSuccess] = useState<string>();
    const [salvabile, setSalvabile] = useState<boolean>();
    const [application,] = useGlobal<IGlobalState, 'application'>('application');
    const [identity] = useGlobal<IGlobalState, 'identity'>('identity');

    function fileNameChanged(e: any) {
        // eslint-disable-next-line
        let { name, value } = e.target;
        setSalvabile(true);
        setfileName(value);
    }

    function handleSave() {
        resetFields();
        let identificativo = "";
        if(application === 1)
        {
            identificativo = (props.state as IMyAppState).nomeCognome;
        }
        else if(application === 2)
        {
            identificativo = (props.state as SimulazioniSrlDataClass).datiSimulazioniSrl.G48;
        }
        else if(application === 3)
        {
            identificativo = (props.state as SchedaBudgetDataClass).informazioniCostiDiAvvio.nomeDitta;
        }

        saveElaborazione(auth.getProvincia(global)!, identity?.Username!, fileName, application, identificativo , "PIVA", "UFFICIO", JSON.stringify(props.state), global)
            .then(x => { setSuccess("Elaborazione salvata correttamente"); setSalvabile(false); })
            .catch(error => {
                setError(error.toString());
            });
    }

    function resetFields() {
        setSuccess("");
        setError("");
        setSalvabile(true);
    }

    function handleClose() {
        resetFields();
        props.handleClose();
    }

    return (
        <div className={gClasses.root}>
            <Dialog
                open={props.isOpen}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Salva elaborazione"}</DialogTitle>
                <DialogContent dividers>
                    <Grid
                        container
                        direction="column"
                        justify="center"
                        alignItems="center"
                    >
                        <TextField
                            id="saveNameTxtfld"
                            label="Nome elaborazione"
                            value={fileName}
                            onChange={fileNameChanged}
                            margin="normal"
                            style={{ width: "20rem" }}
                        />
                        <Typography color={"error"} variant="caption">{error}</Typography>
                        <Typography color={"secondary"} variant="caption">{success}</Typography>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Fab disabled={!salvabile} onClick={handleSave}>
                        <CheckIcon style={{ width: '2rem', height: '2rem' }} color="primary" titleAccess="Salva"/>
                    </Fab>
                    <Fab onClick={handleClose}>
                        <ExitIcon style={{ width: '2rem', height: '2rem' }} color="secondary" titleAccess="Chiudi"/>
                    </Fab>
                </DialogActions>
            </Dialog>
        </div>
    );
}